export default __webpack_public_path__ + "static/media/checkbox_tick.ae76d127.svg";